import React, { useContext, useMemo } from 'react'
import { FieldProps } from 'formik'
import { cn } from '../../lib/utils'
import { IsDisabledContext } from '../../model/context/IsDisabledContext'

interface Props extends FieldProps {
  label: string | React.ReactNode
  comment?: string
  className?: string
  disabled?: boolean
  truthyValue?: string | number | boolean
  falseyValue?: string | number | boolean
}

export const CheckboxInput: React.FC<Props> = (props) => {
  const disabled = useContext(IsDisabledContext) || props.disabled || false
  const { truthyValue = true, falseyValue = false } = props

  const checked = useMemo(() => {
    return props.field.value === truthyValue
  }, [props.field.value, truthyValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? truthyValue : falseyValue

    return props.form.setFieldValue(props.field.name, newValue)
  }

  return (
    <div className={cn('relative flex items-start', props.className)}>
      <div className="flex h-6 items-center">
        <input
          id={props.field.name}
          aria-describedby={`${props.label}-description`}
          name={props.field.name}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={cn(
            'h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600',
            disabled && 'bg-gray-100 text-gray-400 focus:ring-gray-600',
          )}
        />
      </div>
      <div className="ml-3 text-sm leading-6">
        <label htmlFor={props.field.name} className="font-medium text-gray-900">
          {props.label}
        </label>
        {props.comment && (
          <p id={`${props.field.name}-description`} className="text-gray-500">
            {props.comment}
          </p>
        )}
      </div>
    </div>
  )
}
